import api from './api';

export interface DailyReportRow {
  device_group: string;
  device_name: string;
  ip_address: string | null;
  conn_status: string | null;
  uptime: string | null;
  cpu: string | null;
  mem: string | null;
  disk: string | null;
  interface_st: string | null;
  last_log: string | null;
  service_st: string | null;
  checked_at: string | null;
  collected_at: string | null;
}

export interface DailyReportGroups {
  홀딩스계열: DailyReportRow[];
  제강계열: DailyReportRow[];
  공통: DailyReportRow[];
}

export interface DailyReportData {
  period: string;
  collectionStatus: 'SUCCESS' | 'FAILED' | 'PARTIAL' | null;
  collectedAt: string | null;
  attemptCount: number | null;
  groups: DailyReportGroups;
}

export interface DailyReportCollectionLog {
  id: string;
  period: string;
  collectionStatus: 'SUCCESS' | 'FAILED' | 'PARTIAL';
  attemptCount: number;
  errorMessage: string | null;
  collectedAt: string | null;
  createdAt: string;
}

export interface CollectDailyReportResult {
  period: string;
  status: 'SUCCESS' | 'FAILED';
  deviceCount?: number;
  attemptCount: number;
  errorMessage?: string;
}

export const dailyReportService = {
  async getPeriods(): Promise<string[]> {
    const res = await api.get<{ periods: string[] }>('/daily-report/periods');
    return res.data.periods;
  },

  async getData(period: string): Promise<DailyReportData> {
    const res = await api.get<DailyReportData>('/daily-report/data', { params: { period } });
    return res.data;
  },

  async getCollectionLogs(limit = 200): Promise<DailyReportCollectionLog[]> {
    const res = await api.get<DailyReportCollectionLog[]>('/daily-report/collection-log', { params: { limit } });
    return res.data;
  },

  async deletePeriod(period: string): Promise<{ deletedDataCount: number; deletedLogCount: number }> {
    const res = await api.delete<{ deletedDataCount: number; deletedLogCount: number }>(`/daily-report/data/${period}`);
    return res.data;
  },

  async getMyGroups(): Promise<string[]> {
    const res = await api.get<{ groups: string[] }>('/daily-report/my-groups');
    return res.data.groups;
  },

  /** 항상 현재 시각 기준(당일) period만 수집한다 — 외부 API가 실시간 스냅샷이라 과거 재수집은 불가능하다. */
  async collectNow(): Promise<CollectDailyReportResult> {
    const res = await api.post<CollectDailyReportResult>('/daily-report/collect');
    return res.data;
  },
};
